const steps = [
  { num: '01', label: 'Fotoğrafını seç', icon: 'ri-image-line' },
  { num: '02', label: 'WhatsApp\'tan gönder', icon: 'ri-whatsapp-line' },
  { num: '03', label: 'Kılıfını al!', icon: 'ri-gift-line' },
];

export default function CustomCase() {
  return (
    <section id="ozel-baski" className="py-20 md:py-28 bg-[#111111] relative overflow-hidden">
      {/* Background accent */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-[#FF4500]/5 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute bottom-0 left-0 w-[300px] h-[300px] bg-[#FF4500]/5 rounded-full blur-3xl pointer-events-none" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10">
        <div className="grid lg:grid-cols-2 gap-10 md:gap-16 items-center">
          {/* Left – Image */}
          <div className="relative order-2 lg:order-1">
            <div className="relative rounded-3xl overflow-hidden aspect-[4/5]">
              <img
                src="https://readdy.ai/api/search-image?query=young%20person%20holding%20a%20custom%20printed%20phone%20case%20with%20their%20own%20photo%20on%20it%2C%20warm%20studio%20lighting%2C%20street%20style%20fashion%2C%20orange%20and%20black%20color%20palette%2C%20happy%20satisfied%20customer%20showing%20custom%20iPhone%20case%20with%20vibrant%20print%20quality&width=800&height=1000&seq=custom001&orientation=portrait"
                alt="Kişiye Özel Kılıf"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
            </div>

            {/* Floating badge */}
            <div className="absolute -bottom-4 -right-2 md:right-6 bg-[#FF4500] text-white rounded-2xl px-5 py-4 shadow-2xl shadow-[#FF4500]/30">
              <p className="text-2xl font-black" style={{ fontFamily: "'Bebas Neue', sans-serif" }}>24 Saat</p>
              <p className="text-xs font-semibold text-white/80 uppercase tracking-wide">Hızlı Teslimat</p>
            </div>

            {/* Floating star badge */}
            <div className="absolute -top-3 -left-2 md:left-6 bg-white text-black rounded-2xl px-4 py-3 shadow-2xl">
              <div className="flex items-center gap-1">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-amber-400 text-sm w-3 h-3 flex items-center justify-center" />
                ))}
              </div>
              <p className="text-xs font-bold text-black/70 mt-0.5">500+ Mutlu Müşteri</p>
            </div>
          </div>

          {/* Right – Content */}
          <div className="order-1 lg:order-2">
            <p className="text-white/40 text-xs font-bold uppercase tracking-[0.3em] mb-3">Sadece Sana Özel</p>
            <h2
              className="text-white uppercase leading-none mb-5"
              style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 'clamp(2.2rem, 6vw, 4.5rem)' }}
            >
              Kendi Kılıfını
              <br />
              <span className="text-[#FF4500]">Kendin Tasarla!</span>
            </h2>
            <p className="text-white/60 text-base md:text-lg leading-relaxed mb-8">
              Fotoğrafını gönder, sana özel baskıyı hazırlayalım.
              İster kendine, ister hediye! Her modele uygun kılıf üretimi yapıyoruz.
            </p>

            {/* Steps */}
            <div className="flex flex-col gap-4 mb-10">
              {steps.map((step) => (
                <div key={step.num} className="flex items-center gap-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-white/8 border border-white/12 rounded-xl shrink-0">
                    <i className={`${step.icon} text-white/70 text-base`} />
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="text-white/30 text-xs font-bold">{step.num}</span>
                    <span className="text-white font-semibold text-sm md:text-base">{step.label}</span>
                  </div>
                </div>
              ))}
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="https://wa.me/903222286464?text=Merhaba!%20Kişiye%20özel%20kılıf%20yaptırmak%20istiyorum.%20Fotoğrafımı%20gönderebilir%20miyim?"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 bg-[#FF4500] hover:bg-[#e03d00] text-white px-7 py-4 rounded-full font-bold text-sm transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer shadow-lg shadow-[#FF4500]/25"
              >
                <i className="ri-image-add-line w-4 h-4 flex items-center justify-center" />
                Fotoğraf Gönder
              </a>
              <a
                href="https://wa.me/903222286464?text=Hemen%20sipariş%20vermek%20istiyorum!"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 bg-white/10 hover:bg-white/15 border border-white/20 text-white px-7 py-4 rounded-full font-bold text-sm transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-shopping-bag-line w-4 h-4 flex items-center justify-center" />
                Hemen Sipariş Ver
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
